/* eslint no-console:0 */
/*
  Extrenal libraries for global usage
*/

import { i18n } from '../javascript/i18n'
import 'jquery-ui-bundle'

import Rails from '../javascript/ujs'
Rails.start()

import '../javascript/jquery'
import '../javascript/functions'

import {Application} from "@hotwired/stimulus"
import FilterController from '../javascript/controllers/filter_controller'
import DependentSelectController from '../javascript/controllers/dependent_select_controller'
import TemplateController from "../javascript/controllers/template_controller"
import AlternativesController from "../javascript/controllers/alternatives_controller"
import DestroyController from  "../javascript/controllers/destroy_controller"
import CollapseController from "../javascript/controllers/collapse_controller";
import DropdownController from "../javascript/controllers/dropdown_controller";
import RepeatingToggleController from "../javascript/controllers/repeating_toggle_controller";
import ToggleController from "../javascript/controllers/toggle_controller";
import DialogController from "../javascript/controllers/dialog_controller";
import TextareaController from "../javascript/controllers/textarea_controller";
import ColorContrastController from "../javascript/controllers/color_contrast_controller";
import ResponsiveMenuController from "../javascript/controllers/responsive-menu-controller";
import FlexWrapController from "../javascript/controllers/flex_wrap_controller";
import TextInputController from "../javascript/controllers/text_input_controller";
import LeftPanelController from "../javascript/controllers/left_panel_controller";
import BidirectionalScrollController  from "../javascript/controllers/bidirectional_scroll_controller";
import CalendarPageController from "../javascript/controllers/calendar_page_controller";
import FlashController from "../javascript/controllers/flash_controller";
import SelectSearchController from "../javascript/controllers/select_search_controller";
import EntityChangeController  from "../javascript/controllers/entity_change_controller";

const application = Application.start()
application.register("filter", FilterController)
application.register("dependent-select", DependentSelectController)
application.register("template", TemplateController)
application.register("alternatives", AlternativesController)
application.register("collapse", CollapseController)
application.register("destroy", DestroyController)
application.register("dropdown", DropdownController)
application.register("repeating-toggle", RepeatingToggleController)
application.register("toggle", ToggleController)
application.register("dialog", DialogController)
application.register("textarea", TextareaController)
application.register("color-contrast", ColorContrastController)
application.register("left-panel", LeftPanelController)
application.register("responsive-menu", ResponsiveMenuController)
application.register("bidirectional-scroll", BidirectionalScrollController)
application.register("left-panel", LeftPanelController)
application.register("bidirectional-scroll", BidirectionalScrollController)
application.register('calendar-page', CalendarPageController)
application.register("flash", FlashController)
application.register("entity-change", EntityChangeController)
application.register("select-search", SelectSearchController)
application.register("flex-wrap", FlexWrapController)
application.register("text-input", TextInputController)

// i18n pluralization rules for Czech language
window.I18n.pluralization.register('cs', (i18n, count) => {
  if (count === 1) return ['one'];
  if (count >= 2 && count <= 4) return ['few'];
  return ['other'];
});

//direct upload library
import '../javascript/direct_upload' 

// flatpicker initialization
import '../javascript/initialize_flatpicker'

// select2 initialization
import '../javascript/select.js'

// map for/of devices 
import '../javascript/map_link.js'

// soft delete 
// TODO: make it generic
import '../javascript/soft_delete_person.js'
import '../javascript/soft_delete_document.js'
import '../javascript/soft_delete_device.js'
import '../javascript/soft_delete_device_type.js'

// Trailblazer cells scripts
import '../../cells/activation/activation_cell'


// injects images used in the application
import.meta.glob('./images/gfx')
